import { FolderGoogleDriveIcon } from './FolderGoogleDriveIcon';

/**
 * author: Google
 * id B8ACEEFF-E80A-42A9-BCAE-A804D47D8929
 * name folder-google-drive
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-google-drive.svg
 * tags
 * - Files / Folders 
 * - Brand / Logo 
 */
export const FolderMydriveIcon = FolderGoogleDriveIcon;
export default FolderMydriveIcon